import type {
  GalleryOpenMediaLocation,
  GalleryOpenMediaType,
  GalleryViewMedia,
} from '../../types/galleryTypes';

export const mediaItemToType = (
  item: GalleryViewMedia | undefined,
): GalleryOpenMediaType => {
  if (!item) return 'standard image';
  if (item.is360) return '360 image';
  if (item.isVideo || item.isIframe) return 'video';
  return 'standard image';
};

export const THUMBNAIL_LOCATIONS: readonly GalleryOpenMediaLocation[] = [
  'thumbnail 1',
  'thumbnail 2',
  'thumbnail 3',
] as const;
